import Action from '../Action'
// import './styles/ModalDeleteUSer.css'
import { useState } from 'react';
import LoadSimple from '../LoadSimple';
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
const ModalDeleteUSer =({search_data,handleShowPopup,languaje,url,data_id,data_text,title,nivel,user,closDeleteUserModal,setData,setLoading,setError,server})=>{
    const [loadingM,setLoadingM]=useState(false);
    
    const getCurrentDateTime = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
    const Eliminar=()=>{
        
       
        setLoadingM(true)
          const fetchDataPost = async () => {
            
            let req_id=data_id
            const body = new URLSearchParams();
        
            // let body = new FormData();
            body.append("closed_at", getCurrentDateTime());
            let array=[data_id]
            
            if(nivel==3){
              req_id=''
              body.append("cassia_tech_device_ids", array);
            }
         try {
              const response = await fetch(server.url+'/api/v1/cassia/'+url+''+req_id, {
                method: 'DELETE',  
                headers: {
                  "Accept": "application/json",
                  // 'Content-Type': 'application/json',
                  "Content-Type": "application/x-www-form-urlencoded",
                  Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                },
                // body:JSON.stringify(body)
                body:body
              });
             
              if (response.ok) {
                
                const data1 = await response.json();
                setLoadingM(false)
                // Manejo de la respuesta
                setData(data1)
                handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['regDeleteCorr'])),'', true)
                search_data()
                closDeleteUserModal()
                
                // console.log(data1);
              } else {
                const data1 = await response.json();
                handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regDeleteNoCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
                throw new Error('Error en la solicitud');
              }
            } catch (error) {
              handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regDeleteNoCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
              // Manejo de errores
              setError(error)
             
            }
          };
      
          fetchDataPost();
          
    }
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs delete-modal-gs'>
                            <div className='head-card-modal-gs delete-modal-gs'>
                                
                            </div>
                            <div className='content-card-modal-gs'>
                                <div className='cont-info-modal-delete-gs'>
                                    <div className='cont-message-modal-delete-gs'>
                                            <div className='txt-message-modal-delete-gs'>
                                                {capitalizeFirstLetter(lang[languaje]['eliminar'])+'  '+title+':'}
                                            </div>
                                    </div>
                                    <div className='cont-user-modal-delete-gs'>
                                            <div className='txt-user-modal-delete-gs'>
                                                {data_id + " - "+data_text}
                                            </div>
                                    </div>
                                    <div className='cont-btn-modal-delete-gs'>
                                            {
                                                (loadingM)?<LoadSimple></LoadSimple>:
                                                <>
                                                <Action  disabled={false} origen='Red' titulo={capitalizeFirstLetter(lang[languaje]['aceptar'])}  action={Eliminar}></Action>
                                                <Action  disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closDeleteUserModal}></Action>
                                                </>
                                            }
                                    </div>
                                </div>
                            </div>
            </div>
        </div>
    )
}

export default ModalDeleteUSer